import React from 'react';
import { createIcon } from './create-icon';
import './icon-edit.scss';

export const IconEdit = createIcon(<div className="icon-edit" />);
